//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';

export class FragQueryTimelineQuantityBody{
	public apiKey?:string;
	public email?:string;
	public authToken?:string;
	public deviceId:number;
	public begin:DateTime;
	public end:DateTime;
	public weightType:string;
	public chunkSize:number;
}

export namespace FragQueryTimelineQuantityBody{
	export const meta=new ModelMeta<keyof Props>(
		"FragQueryTimelineQuantityBody",
		[],
		[
			{
				name: "apiKey",
				type: "string",
				decorators: {},
				notNull: true,
				optional: true
			},{
				name: "email",
				type: "string",
				decorators: {},
				notNull: true,
				optional: true,
				comment: "needs either apiKey | {email,authToken}"
			},{
				name: "authToken",
				type: "string",
				decorators: {},
				notNull: true,
				optional: true
			},{
				name: "deviceId",
				type: "number",
				decorators: {},
				notNull: true
			},{
				name: "begin",
				type: "date",
				decorators: {},
				notNull: true
			},{
				name: "end",
				type: "date",
				decorators: {},
				notNull: true
			},{
				name: "weightType",
				type: "string",
				decorators: {},
				notNull: true
			},{
				name: "chunkSize",
				type: "number",
				decorators: {},
				notNull: true,
				comment: "area|'volume';"
			}
		]
	);

	interface Props{
		apiKey?:string;
		email?:string;
		authToken?:string;
		deviceId:number;
		begin:DateTime;
		end:DateTime;
		weightType:string;
		chunkSize:number;
	}

}
